import React, { useState } from "react";
import ImageCarousel from "../../../components/ImageCarousel";
import classes from "./index.module.css";
import AppLogo from "../../../assets/images/mainLogo.png";
import { ValidatorForm } from "react-material-ui-form-validator";
import "../../../assets/css/style.css";
import { Button, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../../components/AlertBox";

const SelectLanguage = () => {
  const navigate = useNavigate();
  const [preferedLanguage, setPreferedLanguage] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const lang = localStorage.getItem("language");
  const handleSubmit = () => {
    if (preferedLanguage) {
      localStorage.setItem("language", preferedLanguage);
      navigate("/personal-details");
    } else {
      setShowAlert(true);
      setError("Please select your language");
    }
  };
  return (
    <div className={classes.maindivForlogin}>
        <Card className={classes.SelectLanguage_maindiv}>
          <div>
            <ImageCarousel />
          </div>
          <ValidatorForm useref="form" onSubmit={handleSubmit}>
            <div className={classes.MaincntainerDiv}>
              <div className={classes.formContent}>
                <div>
                  <span className={classes.mb_5}>
                    <img src={AppLogo} alt="" height="50" />
                  </span>
                  <Typography className={classes.loginHeading}>
                    Choose your Preferred Language
                  </Typography>
                  <Typography className={classes.loginDescription}>
                    Please select your language
                  </Typography>
                </div>

                <div className={classes.mt_4}>
                  <div className={classes.langBox}>
                    <div
                      onClick={() => setPreferedLanguage("en")}
                      className={`${classes.languageOption} ${
                        preferedLanguage === "en"
                          ? classes.activeLAnguageBtn
                          : classes.nonActiveLanfuageBtn
                      }`}
                    >
                      English (United States)
                    </div>
                    <div
                      onClick={() => setPreferedLanguage("hi")}
                      className={`${classes.languageOption} ${
                        preferedLanguage === "hi"
                          ? classes.activeLAnguageBtn
                          : classes.nonActiveLanfuageBtn
                      }`}
                    >
                      Hindi ( हिंदी )
                    </div>
                  </div>
                  <div className={classes.mt_5}>
                    <Button
                      className={classes.commonbtn}
                      type="submit"
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </ValidatorForm>
        </Card>
      {showAlert && error && (
        <AlertBox type="error" message={error} stateName={setShowAlert} />
      )}
    </div>
  );
};

export default SelectLanguage;
